<template>

  <div class="common-seach-wrap" v-loading="loading">
    <el-tabs v-model="visionName">
      <el-tab-pane label="视力数据" name="first"></el-tab-pane>
      <el-tab-pane v-if="is_auth" label="数据管理员" name="second"></el-tab-pane>
    </el-tabs>
    <Vision v-if="visionName == 'first'"></Vision>
    <Manager v-if="visionName == 'second'"></Manager>

  </div>
</template>
<script>
  import Manager from './manager/index';
  import Vision from './vision/index';
  import VisionApi from '@/api/vision.js';
  export default {
    components: {
      Vision,
      Manager
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        is_auth:false,
        form: {
          status: 0
        },
        visionName: 'first'
      };
    },
    created() {
      this.auth();
    },
    methods: {
      auth(){
        let self= this;
        VisionApi.auth({}, true)
          .then(data => {
            self.loading=false;
            self.is_auth =  data.data.is_auth;
          })
          .catch(error => {});
      }
    },
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/vision/index.vue